import { getDocsUrl } from "utils/getDocsUrl";

export const SCHEDULE_DEMO_BUTTON_TEXT = "Schedule a Demo";
export const DOCUMENTATION_BUTTON_TEXT = "Documentation";
export const GO_TO_LAUNCHPAD_BUTTON_TEXT = "Go to Launchpad";
export const ANALYTICS_TITLE_BUTTON_CLICKED = "Button clicked";
export const DOCUMENTATION_URL = getDocsUrl();
export const LAUNCHPAD_NAVIGATE_PATH = "/launchpad";
